import CrudRepository from './CrudRepository'
export default class PaymentsExport extends CrudRepository {
  constructor () {
    super('core/api/users/recentPayment/export')
  }
}
